export default "__VITE_ASSET__BG92o5QW__"